import { useEffect } from 'react';
import { useBrand } from './useBrand.js';

/**
 * Dynamically sets the document title following the pattern:
 *   {context} — {section} — {appName}
 *
 * Pass undefined/null parts to omit them.
 *
 * @example
 *   usePageTitle('Game #42', 'Scoreboard'); // => "Game #42 — Scoreboard — ACO"
 *   usePageTitle(null, 'Lobby');             // => "Lobby — ACO"
 */
export function usePageTitle(context?: string | null, section?: string | null): void {
  const brand = useBrand();

  useEffect(() => {
    const parts = [context, section, brand.shortName].filter(Boolean);
    document.title = parts.join(' — ');
  }, [context, section, brand.shortName]);
}
